const currencies = [
  {
    currency: 'TRY',
  },
  {
    currency: 'USD',
  },
  {
    currency: 'RUB',
  },
  {
    currency: 'EUR',
  },
  {
    currency: 'BYN',
  },
];

export default currencies;
